export enum OwnershipTransferStep {
  SelectCompany = 'SelectCompany',
  Dashboard = 'Dashboard',
  SelectActionType = 'SelectActionType',
  ValidateCustomer = 'ValidateCustomer',
  BanSelecting = 'BanSelecting',
  FutureAccountType = 'FutureAccountType',
  EquipmentObligations = 'EquipmentObligations',
  CustomerForm = 'CustomerForm',
  ContactPersonForm = 'ContactPersonForm',
  SuccessPage = 'SuccessPage',
  GeneralMessage = 'GeneralMessage',
  ResendSuccessPage = 'ResendSuccessPage',
  UploadFile = 'UploadFile',
  ErrorPageBulkRequest = 'ErrorPageBulkRequest',
  SuccessPageBulkRequest = 'SuccessPageBulkRequest',
  ResendMLSuccessPage = 'ResendMLSuccessPage',
}

export enum PopupEnum {
  ExistingRequest = 'ExistingRequest',
  CustomerValidationResult = 'CustomerValidationResult',
  RowValidationResult = 'RowValidationResult',
}
export enum OwnershipTransferActionType {
  BusinessToPrivate = 'BusinessToPrivate',
  PrivateToBusiness = 'PrivateToBusiness',
  FullFundingToSeparate = 'FullFundingToSeparate',
}
export enum OwnershipTransferActionSubType {
  SingleTransfer = 'SingleTransfer',
  BulkTransfer = 'BulkTransfer',
}
export enum OwnershipTransferActionTypeDescription {
  BusinessToPrivate = 'מהעסקי לפרטי',
  PrivateToBusiness = 'מהפרטי לעסקי',
  FullFundingToSeparate = 'ממימון מלא למפוצל',
}
export enum RequestExecutedByDescription {
  ContactPerson = 'איש קשר',
  ServiceManager = 'אחראי/ת שירות',
}
export enum FutureBusinessAccountType {
  Undefined = 'Undefined',
  Private = 'Private',
  BusinessSplit = 'BusinessSplit',
  BusinessFullFunding = 'BusinessFullFunding',
}

export enum FormSendType {
  sms = 'sms',
  email = 'email',
}
export enum EquipmentPaymentObligation {
  None = 'None', //אין חיובים
  Customer = 'Customer', //העברת החיוב למנוי"
  Organization = 'Organization', //העברת החיוב לחשבון החברה
}
export enum RequestStatus {
  SentForSignature = 'SentForSignature',
  AwaitingContactPersonSignature = 'AwaitingContactPersonSignature',
  AwaitingSubscriberSignature = 'AwaitingSubscriberSignature',
  AwaitingForJoin = 'AwaitingForJoin',
  SignedAwaitingForJoin = 'SignedAwaitingForJoin',
  Signed = 'Signed',
  Expired = 'Expired',
  Cancelled = 'Cancelled',
  TransferredForManualProcessing = 'TransferredForManualProcessing',
  Finished = 'Finished',
}
export enum RequestStatusDescription {
  SentForSignature = 'נשלח לחתימות',
  AwaitingContactPersonSignature = 'ממתין לחתימת איש הקשר',
  AwaitingSubscriberSignature = 'ממתין לחתימת המנוי',
  AwaitingForJoin = 'ממתין להצטרפות',
  SignedAwaitingForJoin = 'נחתם - ממתין להצטרפות',
  Signed = 'נחתם - ממתין להצטרפות',
  Expired = 'לא בתוקף',
  TransferredForManualProcessing = 'הועבר לטיפול השירות',
  Finished = 'הושלם',
}

export enum UpdateFormType {
  UpdateAndSend = 'UpdateAndSend',
  SendOnly = 'SendOnly',
  UpdateOnly = 'UpdateOnly',
  Cancel = 'Cancel',
  SendML = 'SendML',
}

const brandNameHe = () => window.Config?.brand_Name_HE;

export const MessageContent = {
  GeneralError: {
    title: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    secondTitle: 'באפשרותך לנסות שוב או לפנות לאחראי השירות',
    secondTitleJet: 'באפשרותך לנסות שוב ',
    icon: require('../Icons/error.svg'),
    secondButtonText: 'חזרה לאזור האישי',
    secondButtonClick: 'businessLobby',
    report: 'generalError',
  },
  AvailableBanError: {
    title: 'לא ניתן להמשיך בהעברת הבעלות לחברה',
    secondTitle: 'עליך לפנות לאחראי/ת השירות להמשך טיפול',
    secondTitleJet: '',
    icon: require('../Icons/error.svg'),
    secondButtonText: 'חזרה לאזור האישי',
    secondButtonClick: 'businessLobby',
  },
  ManualProgress: {
    icon: require('../Icons/v.svg'),
    title: 'קבלנו את הפרטים שלך להעברת הבעלות, נציגנו יצרו איתך קשר בהקדם להשלמת התהליך',
    secondTitle: 'מספר פניה: {fuNumber}',
    buttonText: 'סיום',
    buttonClick: 'goToDashboard',
  },
};

export const PopupMessageContent = {
  InProgress: {
    title: 'למנוי {selectedPhoneNumber} כבר קיימת <br /> בקשה להעברת בעלות',
    secondTitle: 'לא ניתן לבצע העברת בעלות נוספת על אותו המנוי. אפשר <br /> לבטל את העברת הבעלות הקיימת או לחפש מנוי אחר',
    buttonText: 'חיפוש מנוי אחר',
    buttonClick: 'closePopup',
    secondButtonText: 'חזרה לטבלת סטטוס',
    secondButtonClick: 'goToDashboard',
    report: 'inProgress',
  },
  MemberOfDifferentOrg: {
    title: 'מנוי מספר {selectedPhoneNumber}<br /> לא משוייך לארגון זה',
    secondTitle: `<div><div>אם ברצונך לבצע העברת בעלות על מנוי זה עליך להתנתק ולהתחבר עם הארגון:</div><div class='member-of-diff-org-orgData semi'>ח״פ: {customerHetPay} | {customerOrgName}</div> </div>`,
    buttonText: 'חיפוש מנוי אחר',
    buttonClick: 'closePopup',
    secondButtonText: 'חזרה לאזור האישי',
    secondButtonClick: 'businessLobby',
    report: 'memberOfDifferentOrg',
  },
  BusinessAccountType: {
    title: 'המנוי כבר קיים במימון מפוצל',
    secondTitle: `המנוי שאתם מנסים להעביר בעלות הוא כבר מנוי במימון מפוצל של הארגון. נסו מנוי אחר או פנו לאחראי/ת השירות`,
    secondTitleJet: `המנוי שאתם מנסים להעביר בעלות הוא כבר מנוי במימון מפוצל של הארגון. נסו מנוי אחר`,
    buttonText: 'חיפוש מנוי אחר',
    buttonClick: 'closePopup',
  },
  AccountNotFound: {
    title: 'מנוי מספר {selectedPhoneNumber}<br /> לא משוייך לארגון',
    secondTitle: `אפשר לחפש מנוי אחר או לפנות לאחראי/ת השירות`,
    secondTitleJet: `אפשר לחפש מנוי אחר`,
    buttonText: 'חיפוש מנוי אחר',
    buttonClick: 'closePopup',
    report: 'accountNotFound',
  },
  ValidateCustomerGeneralError: {
    title: 'לטובת ביצוע העברת בעלות על מנוי {selectedPhoneNumber} יש לפנות לאחראי/ת השירות',
    titleJet: 'לא ניתן להעביר בעלות למנוי {selectedPhoneNumber}',
    secondTitle: `מספר הערה 142801`,
    secondTitleJet: 'המנוי אינו בסטטוס/סגמנט המתאים או שקיימת תעודת זהות נוספת ברשומת הלקוח',
    buttonText: 'חיפוש מנוי אחר',
    buttonClick: 'closePopup',
  },
  ErrorSubStatus: {
    title: 'מנוי מספר {selectedPhoneNumber} מושהה',
    secondTitle: `לא ניתן להעביר בעלות מנוי בסטטוס מושהה,<br /> יש לפנות לאחראי/ת השירות`,
    secondTitleJet: `לא ניתן להעביר בעלות מנוי בסטטוס מושהה`,
    buttonText: 'חיפוש מנוי אחר',
    buttonClick: 'closePopup',
    report: 'errorSubStatus',
  },
  ErrorNPStatus: {
    title: 'מנוי מספר {selectedPhoneNumber}<br /> נמצא בתהליך ניוד',
    secondTitle: `לא ניתן להשלים את העברת הבעלות בזמן תהליך ניוד`,
    buttonText: 'חיפוש מנוי אחר',
    buttonClick: 'closePopup',
    report: 'errorNPStatus',
  },
  ErrorAbroad: {
    title: `מנוי מספר {selectedPhoneNumber}<br /> נמצא בחו''ל`,
    secondTitle: `לא ניתן להעביר בעלות למנוי שנמצא בחו''ל`,
    buttonText: 'חיפוש מנוי אחר',
    buttonClick: 'closePopup',
    report: 'errorAbroad',
  },
  DataAccount: {
    title: `מנוי מספר {selectedPhoneNumber} הינו מנוי דאטה`,
    secondTitle: `לתשומת ליבך, החבילות שיוצעו למנוי הן חבילות מדף משלובות`,
    buttonText: 'הבנתי, תודה',
    buttonClick: 'validateAccountNextStep',
    report: 'dataAccount',
  },
  IdNumberError: {
    title: 'מספר תעודת זהות לא תואם',
    get secondTitle() {
      return `הפרטים שהוזנו אינם תואמים את הפרטים הקיימים במערכות ${brandNameHe()}, אפשר לנסות שוב או לפנות לאחראי/ת השירות`;
    },
    get secondTitleJet() {
      return `הפרטים שהוזנו אינם תואמים את הפרטים הקיימים במערכות ${brandNameHe()}, אפשר לנסות שוב`;
    },
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
  },
  CancelOwnershipTransfer: {
    title: 'ביטול העברת הבעלות',
    secondTitle: 'שימו לב, במידה ותרצו להשלים העברת בעלות בעתיד, תצטרכו לבצע העברה חדשה',
    buttonText: 'חזרה לטבלת הסטטוס',
    buttonClick: 'closePopup',
    secondButtonText: 'ביטול העברת הבעלות',
    secondButtonClick: 'cancelOwnershipTransferRequest',
    report: 'cancelTransferEnsurePopupDisplayed',
  },
  CancelSuccess: {
    icon: require('../Icons/v.svg'),
    title: 'הבקשה בוטלה בהצלחה!',
    buttonText: 'סיום',
    buttonClick: 'closePopup',
    report: 'cancelSuccess',
  },
};

export const enum fileColName {
  lineNum = "שורה מס'",
  phoneNumber = 'טלפון',
  idNumber = '.ת.ז',
  firstName = 'שם פרטי',
  lastName = 'שם משפחה',
  sendFormValue = 'לאן לשלוח את הטופס לחתימה למנוי',
}

export enum InvalidCellReason {
  IsEmpty = 'ריק',
  ContainDigits = 'מכיל ספרות',
  ContainChar = 'מכיל אותיות',
  InvalidId = ' צריך להכיל 9 ספרות',
  InvalidIsrId = 'לא תקין',
  InvalidPhone = 'צריך להכיל 10 ספרות',
  InvalidType = ' סוג לקוח  תקין',
  general = 'לא תקין',
  IsOverLimit = 'חריגה מהמגבלה',
  InvalidEmail = 'מייל לא טקין',
  InvalidSendFormValue = 'לא תקין',
  DuplicatedNumber = 'מספר כפול',
}
